import * as React from "react";
import RegisterForm, { RegisterFormValues } from "./RegisterForm";

export interface RegisterProps {
  isError: boolean;
  formMsg?: string;
  handleSubmit: (values: RegisterFormValues) => void;
}

const Register = (props: RegisterProps) => (
  <div className="register-form">
    <h4 className="register-form__heading">Thông tin đăng ký</h4>
    <RegisterForm onSubmit={props.handleSubmit} />
    {props.isError && <p className="register-form__error">{props.formMsg}</p>}
  </div>
);

export default Register;



// WEBPACK FOOTER //
// ./src/routes/Account/components/Register.tsx